import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommentService } from '@arkius/shared-api';
import { ModalController, NavController } from '@ionic/angular';
import { take } from 'rxjs';
import { ModerateModalComponent } from '../moderate-modal/moderate-modal.component';
import { environment } from '@shared-envs';

@Component({
  selector: 'ark-lib-moderate-comment-modal',
  templateUrl: './moderate-comment-modal.component.html',
  styleUrls: ['./moderate-comment-modal.component.css'],
})
export class ModerateCommentModalComponent implements OnInit {
  @Input() comment!: any;

  constructor(
    private commentService: CommentService,
    private modalCtrl: ModalController,
    private navController: NavController,
  ) {}

  ngOnInit() {}

  moderateCommentDownvote() {
    this.commentService
      .apiV5CommentCommentIdModerateDownvotePost(this.comment.commentId)
      .pipe(take(1))
      .subscribe({
        next: async () => {
          await this.modalCtrl.dismiss();
          await this.displayModerateCommentThankYouModal(); // Show the modal and wait for it to dismiss
          this.navController.back(); // Navigate back after the modal is dismissed
        },
        error: (error) => {
          environment.log(error);
        },
      });
  }

  moderateCommentUpvote() {
    this.commentService
      .apiV5CommentCommentIdModerateUpvotePost(this.comment.commentId)
      .pipe(take(1))
      .subscribe({
        next: async () => {
          await this.modalCtrl.dismiss();
          await this.displayModerateCommentThankYouModal();
          this.navController.back(); // Show the modal and wait for it to dismiss
        },
        error: (error) => {
          environment.log(error);
        },
      });
  }

  async displayModerateCommentThankYouModal() {
    const modal = await this.modalCtrl.create({
      component: ModerateModalComponent,
    });

    const modalElement = modal.shadowRoot?.querySelector(
      '.modal-wrapper',
    ) as HTMLElement;
    if (modalElement) {
      modalElement.style.width = '90%';
      modalElement.style.borderRadius = '8px';
    }

    // Present the modal and wait for it to be dismissed
    await modal.present();
    await modal.onDidDismiss(); // Wait for the modal to be dismissed
  }
}
